import React from "react";
import {
  DndContext, PointerSensor, useSensor, useSensors, closestCorners,
} from "@dnd-kit/core";
import KanbanColumn from "./KanbanColumn";
import styles from "./Kanban.module.css";

// columns: [{key,title,cards:[...]}], onMove(cardId, toColumn)
export default function KanbanBoard({ columns, onMove, onCardClick, onCardMetrics, onAdd }) {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const columnOfCard = (cardId) => {
    for (const col of columns) {
      if (col.cards.some((c) => String(c.id) === String(cardId))) return col.key;
    }
    return null;
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;
    const cardId = active.id;
    // over.id может быть id карточки или ключ колонки (droppable)
    let targetCol = columns.find((c) => c.key === over.id)?.key;
    if (!targetCol) targetCol = columnOfCard(over.id);
    const fromCol = columnOfCard(cardId);
    if (targetCol && targetCol !== fromCol) {
      onMove(cardId, targetCol);
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCorners} onDragEnd={handleDragEnd}>
      <div className={styles.board}>
        {columns.map((col) => (
          <KanbanColumn
            key={col.key}
            column={col}
            onCardClick={onCardClick}
            onCardMetrics={onCardMetrics}
            onAdd={onAdd}
          />
        ))}
      </div>
    </DndContext>
  );
}
